// resize images and cut watermark
export function resizeImages() {
  const images = document.getElementsByClassName("meme-image");
  for (let image of images) {
    let width = window.innerWidth > 750 ? 608 : window.innerWidth;

    // get orginal image width
    let ogWidth = 888;
    let imageSrc = image.dataset.src || image.src || "";
    let srcSplit = imageSrc.split(".");
    if (srcSplit && srcSplit.length) {
      ogWidth = parseInt(srcSplit[srcSplit.length - 3]);
    }

    let aspectRatio = parseFloat(image.dataset.aspect);
    let bottom = parseInt(image.dataset.bottom);

    let marginBottom = bottom ? (ogWidth === 888 ? -97 : -67) * (width / ogWidth) : 0;

    image.style.minHeight = `${width / aspectRatio}px`;
    image.style.marginBottom = `${marginBottom}px`;

    image.onload = () => {
      image.classList.remove("image-loading");
    };
  }
}
